var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$store.state.authReady)?_c('div',{staticClass:"auth-gate"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Signing in"}}),_c('p',{staticClass:"auth-gate-text"},[_vm._v("Signing you in…")])],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }